import React, { useContext } from 'react'
import * as Constantes from '../../../../utils/constantes'
import styles from '../../Identificacion.module.css'
import GeneralContext from '../../../../context/GeneralContext'

const RenderEmpresa = ({
  state,
  asegurado,
  contratante,
  documentos,
  handleChangeCombo
}) => {
  const { state: generalState } = useContext(GeneralContext)
  let user = generalState.users.filter(user => user.isAuthenticated)[0]
  let prospecto = user.listaProspectos.filter(prospecto => prospecto.isSelected || prospecto.completado)[0]
  let cotizacion = prospecto.cotizaciones.filter(cotizacion => cotizacion.isSelected || cotizacion.completado)[0]

    //Modo lectura
  let Deshabilitar = (complete) => {
    complete = cotizacion.edicionInhabilitada
    if (complete === true && complete !== undefined) {
      return true
    } else {
      return false
    }
  }

  return (
    <React.Fragment>
        <div className={`${styles['grupodeform']} ${styles['top18']}`} style={{ marginRight: '0px' }}>
            <div className={styles['area50']}  style={{ marginRight: '2%' }}>
                <label>Tipo de persona</label>
                <label className={styles.container}>Jurídica
                    <input type="radio" defaultChecked="checked" name="radio" />
                    <span className={styles.checkmark}></span>
                </label>
            </div>
            <div className={styles['area50']}>
                <label style={{marginLeft: '5%'}}>Tipo Doc.</label>
                <select
                    className={!state.campoValidado.tipoDocumentoRL ? `${styles['logerror']} ${styles['tipoDoc']}` : styles['tipoDoc']}
                    style={{marginLeft: '5%'}}
                    value={asegurado !== undefined && asegurado.tipoDocumento
                        ? asegurado.tipoDocumento.codigo
                        : contratante !== undefined && contratante.representanteLegal && contratante.representanteLegal.tipoDocumento
                        ? contratante.representanteLegal.tipoDocumento.codigo
                    : ''}
                    onChange={(e) => handleChangeCombo(e, 'tipoDocumento')}
                    disabled={Deshabilitar() !== true ? asegurado !== undefined
                        ? asegurado.idAsegurado !== undefined
                    : false : true}
                >
                <option value={0}>Seleccione</option>
                    {documentos && documentos.length > 0 && documentos.map(documento => (
                        <option key={documento.id} value={documento.id}>
                            {documento.valor}
                        </option>
                    ))}
                </select>
                <br></br>
                {!state.campoValidado.tipoDocumentoRL &&
                    <span className={styles['span-error']}>{Constantes.MENSAJE_VALIDACION_TIP_DOCUMENTO}</span>
                }
            </div>
        </div>
    </React.Fragment>
  )
}

export default RenderEmpresa
